import React from "react";
import { Train, Bus, Car, Wheelchair, MapPin } from "@phosphor-icons/react";

const ITEMS = [
  { icon: Train, t: "By train", d: "Cambridge South station sits on the Cambridge Biomedical Campus, a short walk from the clinic. It has step-free access with lifts to every platform, and staff can help you on and off the train." },
  { icon: Bus, t: "Campus courtesy bus", d: "Runs from the station across the hospital site, Monday to Friday 8am-6pm." },
  { icon: Car, t: "By car", d: "Paid patient parking is available on the hospital site." },
  { icon: Wheelchair, t: "Need help with access?", d: "Tell us before your visit and we'll help plan your arrival." },
];

export const GettingHere = ({ compact = false }) => (
  <div data-testid="getting-here-card" className={`${compact ? "p-6" : "p-7"} bg-white border border-stone-200/60 rounded-md`}>
    <div className="eyebrow flex items-center gap-2 text-bronze-dark">
      <MapPin size={16} weight="duotone" /> Getting here &amp; accessibility
    </div>
    <p className="mt-3 text-sm text-ink-muted">The clinic is on the Cambridge University Hospitals site, Hills Road, Cambridge CB2 0QQ.</p>
    <ul className="mt-4 space-y-4">
      {ITEMS.map(({ icon: Icon, t, d }) => (
        <li key={t} className="flex gap-3 items-start" data-testid={`getting-here-${t.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "")}`}>
          <Icon size={20} weight="duotone" className="text-bronze-dark shrink-0 mt-0.5" />
          <div className="text-sm"><div className="font-medium text-ink">{t}</div><div className="text-ink-muted leading-relaxed">{d}</div></div>
        </li>
      ))}
    </ul>
  </div>
);
